export const SECURITY_ADMIN_CONSTANTS = Object.freeze({
    ACTION_REQUEST: 'SECURITY_ADMIN__ACTION_REQUEST',
    ACTION_VERIFY: 'SECURITY_ADMIN__ACTION_VERIFY',
});

const C = SECURITY_ADMIN_CONSTANTS;
export const SECURITY_ADMIN_ENDPOINTS = Object.freeze({
    [C.ACTION_REQUEST]: '/security/action/request',
    [C.ACTION_VERIFY]: '/security/action/verify',
});
